import React, { useState } from "react";
import SelectCurrentQuestion from "../SelectCurrentQuestion/SelectCurrentQuestion";
import styles from "./Header.module.css";
// import logo from "../../assets/images/logo.png";
import { ReactComponent as Logo } from "../../assets/icons/logo/goiteens_logo.svg";
import { ReactComponent as RightArrow } from "../../assets/icons/arrow/right-arrow.svg";
import { ReactComponent as LeftArrow } from "../../assets/icons/arrow/left-arrow.svg";

const Header = ({
  blockTasksArr,
  currentTaskId,
  getPrevTask,
  getNextTask,
  passed,
  blockIndex,
  passedTasks,
  getSpecificTask,
  headerTextLogoRef,
  headerTextTaskRef,
}) => {
  const [isOpenSelect, setSelect] = useState(false);
  const openSelect = () => setSelect(true);
  const closeSelect = () => setTimeout(() => setSelect(false), 0);

  const blockQuestionQuantity = blockTasksArr.length;
  const numberCurrentQuestion = blockTasksArr.indexOf(currentTaskId) + 1;
  const showPrevButton =
    blockTasksArr.indexOf(currentTaskId) === 0 ? false : true;
  const showNextButton =
    blockTasksArr.indexOf(currentTaskId) === blockTasksArr.length - 1 || !passed
      ? false
      : true;
  return (
    <header className={styles.header_container}>
      <div className={styles.headerContent}>
        <h1 className={styles.logo_container}>
          <a
            href="https://goiteens.ua/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Logo className={styles.logo} width="90" height="30" />
          </a>
          <span className={styles.logo_title} ref={headerTextLogoRef}>
            Марафон HTML/CSS
          </span>
        </h1>

        <div className={styles.questionCounter_container}>
          {showPrevButton && (
            <button onClick={getPrevTask} className={styles.button}>
              <LeftArrow className={styles.arrow} />
            </button>
          )}
          <div
            className={styles.count}
            onClick={openSelect}
            ref={headerTextTaskRef}
          >
            Задание {numberCurrentQuestion} / {blockQuestionQuantity}
            {isOpenSelect && (
              <SelectCurrentQuestion
                closeSelect={closeSelect}
                passedTasks={passedTasks}
                getSpecificTask={getSpecificTask}
                blockTasksArr={blockTasksArr}
              />
            )}
          </div>
          {showNextButton && (
            <button onClick={getNextTask} className={styles.button}>
              <RightArrow className={styles.arrow} />
            </button>
          )}
        </div>

        <p className={styles.days_container}>
          Марафон:&ensp;<span>день {blockIndex}</span>&ensp;из 6
        </p>
      </div>
    </header>
  );
};

export default Header;
